/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../../shared/components/Localized';
import moment from 'moment';
import Linkify from 'react-linkify';

import { Wrapper, TitleWrapper, Title, Body } from './styles.js';

const Field = ({ feedItem, region, missingTranslations }) => (
  <Linkify properties={{ target: '_blank' }}>
    <Wrapper severity={feedItem.severity}>
      <TitleWrapper>
        <div>
          <Title>
            <Localized
              modelName='field'
              modelKey={feedItem.field}
              modelAttribute='label'
              missingTranslations={missingTranslations}
            />
          </Title>
        </div>
      </TitleWrapper>
      <Body>
        <Localized
          modelName='fieldOption'
          modelKey={feedItem.fieldOption}
          modelAttribute='value'
          missingTranslations={missingTranslations}
          hasLinks
        />
      </Body>
    </Wrapper>
  </Linkify>
);

export default Field;
